<template>
    <div class="latexPop">
        <div class="latexPop-content">
            <span @click="latexPopClose" class="iconfont icon-guanbi"></span>
            <iframe id="latexPop-content" src="http://formula.xesv5.com/mathematics"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        window.addEventListener("message",(e)=>{
            if(!e.data) return
            let content = e.data
            this.latexPopLookFor(content)
        })
    },
    methods: {
        latexPopClose(){
            this.$emit('latexPopClose')
        },
        latexPopLookFor(val){
            this.$emit('latexPopLookFor',val)
        }
    }
}
</script>
<style lang="less">
.latexPop{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 20;
    display: flex;
    justify-content:center;
    align-items:center;
    .latexPop-content{
        width: 545px;
        height: 320px;
        position: relative;
        overflow: hidden;
        iframe{
            width: 100%;
            height: 100%;
        }
        .icon-guanbi{
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
        }
    }
}
</style>




// WEBPACK FOOTER //
// packages/question-filter/src/latexPop.vue